import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var Constants = /*#__PURE__*/function () {
  function Constants() {
    _classCallCheck(this, Constants);
  }
  return _createClass(Constants, null, [{
    key: "URL_API",
    get: function get() {
      return '/services/ajax';
    }
  }, {
    key: "URL_API_KPI_CLICK",
    get: function get() {
      return '/services/kpi/';
    }
  }, {
    key: "CAROUSEL",
    get: function get() {
      return {
        'SELECTOR': 'js-list-products [data-carousel-id]'
      };
    }
  }, {
    key: "PAGINATIONS",
    get: function get() {
      return {
        'SELECTOR': 'js-pagination'
      };
    }
  }, {
    key: "PRODUCT_LIST_SELECTORS",
    get: function get() {
      return {
        'CONTAINER': 'js-list-container',
        'NO_RESULTS': 'js-no-results',
        'CONTENT': 'js-list-content'
      };
    }
  }, {
    key: "ACTION",
    get: function get() {
      return {
        SORT: 'sort',
        PAGINATE: 'paginate',
        FILTER: 'filter'
      };
    }
  }, {
    key: "FILTERS_FORM_SELECTOR",
    get: function get() {
      return 'js-form-filters';
    }
  }, {
    key: "FILTERS_LAYER_CLOSE_BUTTON",
    get: function get() {
      return "js-filters-layer-close-button";
    }
  }]);
}();